/**
 * @generated SignedSource<<f4b3e88c32bdb66ec24760120ffce092>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DublicateWeekInput = {
  clientMutationId?: string | null | undefined;
  id: string;
  programId: string;
};
export type CurriculumEditScreenDuplicateWeekMutation$variables = {
  endNumber: number;
  input: DublicateWeekInput;
  startNumber: number;
};
export type CurriculumEditScreenDuplicateWeekMutation$data = {
  readonly dublicateWeek: {
    readonly program: {
      readonly " $fragmentSpreads": FragmentRefs<"CurriculumEditScreen_program">;
    } | null | undefined;
  } | null | undefined;
};
export type CurriculumEditScreenDuplicateWeekMutation = {
  response: CurriculumEditScreenDuplicateWeekMutation$data;
  variables: CurriculumEditScreenDuplicateWeekMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endNumber"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startNumber"
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "endNumber",
    "variableName": "endNumber"
  },
  {
    "kind": "Variable",
    "name": "startNumber",
    "variableName": "startNumber"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "draft",
    "value": true
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CurriculumEditScreenDuplicateWeekMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DublicateWeekPayload",
        "kind": "LinkedField",
        "name": "dublicateWeek",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Program",
            "kind": "LinkedField",
            "name": "program",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "kind": "FragmentSpread",
                "name": "CurriculumEditScreen_program"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CurriculumEditScreenDuplicateWeekMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DublicateWeekPayload",
        "kind": "LinkedField",
        "name": "dublicateWeek",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Program",
            "kind": "LinkedField",
            "name": "program",
            "plural": false,
            "selections": [
              {
                "alias": "weeks",
                "args": (v4/*: any*/),
                "concreteType": "Week",
                "kind": "LinkedField",
                "name": "weekRange",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "week",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "positions",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "archived",
                        "value": true
                      }
                    ],
                    "concreteType": "Component",
                    "kind": "LinkedField",
                    "name": "components",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "previousStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "weekId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "locked",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "iconName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Program",
                        "kind": "LinkedField",
                        "name": "program",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "imageURL",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v6/*: any*/),
                        "kind": "ScalarField",
                        "name": "content",
                        "storageKey": "content(draft:true)"
                      },
                      {
                        "alias": null,
                        "args": (v6/*: any*/),
                        "kind": "ScalarField",
                        "name": "teaser",
                        "storageKey": "teaser(draft:true)"
                      },
                      {
                        "alias": null,
                        "args": (v6/*: any*/),
                        "kind": "ScalarField",
                        "name": "image",
                        "storageKey": "image(draft:true)"
                      },
                      {
                        "alias": null,
                        "args": (v6/*: any*/),
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": "title(draft:true)"
                      },
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "days",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "repeat",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "duration",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "reminderType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "reminderTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "messageTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "draftExists",
                        "storageKey": null
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isComponentIcon"
                      }
                    ],
                    "storageKey": "components(archived:true)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultView",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "length",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isEmpty",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "52002174b90a3cb0d45aea515859946f",
    "id": null,
    "metadata": {},
    "name": "CurriculumEditScreenDuplicateWeekMutation",
    "operationKind": "mutation",
    "text": "mutation CurriculumEditScreenDuplicateWeekMutation(\n  $input: DublicateWeekInput!\n  $startNumber: Int!\n  $endNumber: Int!\n) {\n  dublicateWeek(input: $input) {\n    program {\n      ...CurriculumEditScreen_program_4rAFyh\n      id\n    }\n  }\n}\n\nfragment CalendarComponentCard_component on Component {\n  title(draft: true)\n  type\n  status\n  locked\n  ...ComponentIcon_component\n}\n\nfragment ChangeComponentCoverDialog_component_3CJfPz on Component {\n  content(draft: true)\n  teaser(draft: true)\n  image(draft: true)\n  ...ComponentPreview_component_3CJfPz\n  program {\n    imageURL\n    id\n  }\n}\n\nfragment ComponentIcon_component on ComponentIcon {\n  __isComponentIcon: __typename\n  iconName\n  type\n}\n\nfragment ComponentPreview_component_3CJfPz on Component {\n  title(draft: true)\n  teaser(draft: true)\n  image(draft: true)\n  ...ComponentIcon_component\n}\n\nfragment CopyComponentDialog_component on Component {\n  id\n  program {\n    id\n  }\n}\n\nfragment CurriculumEditScreen_program_4rAFyh on Program {\n  weeks: weekRange(startNumber: $startNumber, endNumber: $endNumber) {\n    week\n    id\n    positions\n    components(archived: true) {\n      ...ProgramCalendarComponentButtons_component\n      ...ProgramCalendarComponent_component\n      ...WeekComponentList_components\n      ...DragCellRenderer_component\n      id\n      type\n      status\n      iconName\n      weekId\n      title(draft: true)\n      duration\n      repeat\n      days\n      locked\n      content(draft: true)\n      slug\n      draftExists\n    }\n    ...WeekCard_week\n    ...ProgramCalendarWeek_week\n    ...ProgramSpreadsheetWeek_week\n  }\n  id\n  name\n  slug\n  defaultView\n  length\n  isEmpty\n}\n\nfragment DragCellRenderer_component on Component {\n  ...WeekComponentMenu_component\n  id\n  slug\n  type\n  days\n  status\n  locked\n  draftExists\n}\n\nfragment ProgramCalendarComponentButtons_component on Component {\n  ...WeekComponentMenu_component\n  id\n  slug\n  days\n  status\n  locked\n}\n\nfragment ProgramCalendarComponent_component on Component {\n  type\n  slug\n  ...CalendarComponentCard_component\n}\n\nfragment ProgramCalendarWeek_week on Week {\n  id\n  week\n  description\n}\n\nfragment ProgramSpreadsheetWeek_week on Week {\n  id\n  week\n  description\n  positions\n}\n\nfragment SelectComponentIcons_component on Component {\n  id\n  iconName\n  type\n}\n\nfragment WeekCard_week on Week {\n  ...WeekDrawer_week\n  description\n  positions\n  components(archived: true) {\n    ...WeekComponentList_components\n    id\n  }\n}\n\nfragment WeekComponentListItem_component on Component {\n  type\n  status\n  title(draft: true)\n  image(draft: true)\n  days\n  repeat\n  slug\n  locked\n  ...ComponentIcon_component\n  ...WeekComponentMenu_component\n  ...WeekComponentSchedule_component\n}\n\nfragment WeekComponentList_components on Component {\n  ...WeekComponentListItem_component\n  id\n}\n\nfragment WeekComponentMenu_component on Component {\n  id\n  type\n  status\n  previousStatus\n  weekId\n  locked\n  ...SelectComponentIcons_component\n  ...CopyComponentDialog_component\n  ...ChangeComponentCoverDialog_component_3CJfPz\n}\n\nfragment WeekComponentSchedule_component on Component {\n  duration\n  reminderType\n  reminderTime\n  messageTime\n}\n\nfragment WeekDrawer_week on Week {\n  description\n}\n"
  }
};
})();

(node as any).hash = "d78d916b0ff289944a61713b19f97425";

export default node;
